var _line, _rect, _rect2, _path, _path2, _line2, _rect3, _rect4, _rect5, _path3, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleOutlineBelakang(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 330,
    x2: 570,
    y2: 330,
    stroke: "#c7ccd1",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 296,
    width: 30,
    height: 34,
    rx: 6,
    fill: "#2a2e33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 296,
    width: 30,
    height: 34,
    rx: 6,
    fill: "#2a2e33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226 226 L246 156 Q250 142 266 142 L374 142 Q390 142 394 156 L414 226 Z",
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240 220 L257 164 Q259 156 268 156 L372 156 Q381 156 383 164 L400 220 Z",
    fill: "#bfe0ec",
    stroke: "#204d63",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 262,
    y1: 190,
    x2: 378,
    y2: 190,
    stroke: "#204d63",
    strokeWidth: 1,
    strokeDasharray: "4 3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 190,
    width: 26,
    height: 16,
    rx: 5,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 190,
    width: 26,
    height: 16,
    rx: 5,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 220,
    width: 284,
    height: 88,
    rx: 22,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300 236 L340 236",
    stroke: "#204d63",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 234,
    width: 64,
    height: 30,
    rx: 8,
    fill: "#e57373",
    stroke: "#8b3a3a",
    strokeWidth: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 234,
    width: 64,
    height: 30,
    rx: 8,
    fill: "#e57373",
    stroke: "#8b3a3a",
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 276,
    width: 260,
    height: 26,
    rx: 10,
    fill: "#1d4256"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 252,
    width: 60,
    height: 18,
    rx: 3,
    fill: "#e8eaed",
    stroke: "#8b9096",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleOutlineBelakang);
export default __webpack_public_path__ + "static/media/vehicle-outline-belakang.057fc612a11ba26f5357ae1f0cd0f43a.svg";
export { ForwardRef as ReactComponent };